/**
 * Feature flags for the application.
 * Set to true to enable, false to hide/disable.
 */

/** When true, shows the language/locale selector in the header and mobile menu. */
export const SHOW_LOCALE_SELECTOR = true;

/** When true, new pages appear in nav. When false, they are hidden but still reachable via URL. */
export const SHOW_NEW_PAGES_IN_NAV = true;

/** Paths hidden from navigation when SHOW_NEW_PAGES_IN_NAV is false. */
export const HIDDEN_NAV_PATHS = [
  '/execution-governance',
  '/strategic-intelligence',
  '/solutions/industrial-equipment/machine-tools',
  '/solutions/aerospace',
  '/solutions/marine-offshore',
];
